import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleNavigation = (path, sectionId) => {
    if (window.location.pathname !== path) {
      navigate(path);
      setTimeout(() => {
        if (sectionId) {
          scrollToSection(sectionId);
        }
      }, 100);
    } else if (sectionId) {
      scrollToSection(sectionId);
    }
  };

  const handleHomeClick = () => {
    if (window.location.pathname === '/') {
      // Dacă ești deja pe home, reload pentru a reseta formularul
      window.location.reload();
    } else {
      // Dacă ești pe altă pagină, navighează la home
      navigate('/');
    }
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center cursor-pointer" onClick={handleHomeClick}>
            <img
              src="/logo-cf.png"
              alt="CF-Extras.ro - Extrase Carte Funciară Online"
              className="h-16 sm:h-20 lg:h-24 object-contain"
              width="612"
              height="408"
            />
          </div>
          {/* Desktop Menu - ascuns pe mobile */}
          <div className="hidden md:flex space-x-8">
            <button onClick={handleHomeClick} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              Acasă
            </button>
            <button onClick={() => handleNavigation('/', 'preturi')} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              Prețuri
            </button>
            <button onClick={() => handleNavigation('/', 'despre')} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              Despre noi
            </button>
            <button onClick={() => {
              // Trimite event custom către Footer pentru deschidere modal
              window.dispatchEvent(new Event('openContactModal'));
            }} className="text-gray-700 hover:text-emerald-600 font-medium transition-colors">
              Contact
            </button>
          </div>

          {/* Mobile Contact Button - visible doar pe mobile */}
          <button
            onClick={() => {
              window.dispatchEvent(new Event('openContactModal'));
            }}
            className="md:hidden px-4 py-2 min-h-[44px] bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 font-semibold text-sm transition-colors">
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Header;
